import React from 'react'
import { Mic, Code, Trash2 } from 'lucide-react'
import { HeaderProps } from '../types'

const Header: React.FC<HeaderProps> = ({ onClearSession }) => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <div className="p-2 bg-primary-600 rounded-lg">
                <Code className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">DevWhisper</h1>
                <p className="text-sm text-gray-500">AI Voice Coding Mentor</p>
              </div>
            </div>
          </div>

          {/* Status and Controls */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span>AI Ready</span>
            </div>
            
            <button
              onClick={onClearSession}
              className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
              title="Clear session"
            >
              <Trash2 className="h-4 w-4" />
              <span className="hidden sm:inline">Clear Session</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header 